export default __webpack_public_path__ + "assets/images/6368e9bf8044b6d6687022bc4548358b.svg";